import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-light border-top px-3 py-4 mt-auto footer">
      <div className="container d-flex justify-content-between align-items-center">
        <div className="row w-100">
          <div className="col-lg-5 col-12 p-0">
            <img src="/footer_logo.png" alt="Logo" height="32" className="me-2 footer-logo" />
          </div>
          <div className="col-lg-7 col-12 p-0 mt-4 mt-lg-0">
            <div className="text-center text-md-start">
              {/* <a href="/" className="pe-4">Home</a> */}
              <a href="/change-password" className="pe-4">Change Password</a>
              <a href="/support" className="ps-4">Support</a>
            </div>
            <hr style={{ border: "1px solid #87939B", opacity: 0.6 }} />
            <div className="d-flex flex-column flex-md-row justify-content-between text-center text-md-start">
              <div>
                <span>&copy; Copyright {new Date().getFullYear()} Lichic. All rights reserved.</span>
              </div>
              <div>
                <a href="/aboutus" className="pe-3" style={{ borderRight: "1px solid #212121" }}>About Us</a>
                <a href="/terms-conditions" className="pe-3 ps-3" style={{ borderRight: "1px solid #212121" }}>Terms & Conditions</a>
                <a href="/privacy-policy" className="ps-3">Privacy Policy</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
